// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=Lexend:wght@100..900&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Open+Sans:ital,wdth,wght@0,75..100,300..800;1,75..100,300..800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===================== Imports =========================== */
/* @import url("https://fonts.googleapis.com/css2?family=Lexend:wght@100..900&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap"); */

/* ===================== Variables =========================== */

:root {
  --Blue-Dianne: #2b2d42;
  --Rhino-color: #2d455d;
  --Casal-Color: #8d99ae;
  --White-Color: #fff;
  --Black-Color: #000;
  --section-bg: #f5f5f5;
  --nobel-bg: #b5b5b5;

  /* Buttons Color */
  --main-Blue-btn: #058bd3;
  --royal-Green-btn: #244856;
  --royal-Green-disable-btn: #244856d3;
  --royal-Green-hover-btn: #1e3c47;
  --Dove-Gray-btn: #727272;
  --Eastern-Blue: #1eafb3;

  /* Theme Color */
  --primary-50: #eae9ff;
  --primary-100: #c4bef8;
  --primary-200: #9d94ed;
  --primary-300: #7669e4;
  --primary-400: #4f3edb;
  --primary-500: #3624c1;
  --primary-600: #291c97;
  --primary-700: #1d136d;
  --primary-800: #100b43;
  --primary-900: #06031c;

  /* Dark Shades */
  --gray-50: #f2f2f2;
  --gray-100: #d9d9d9;
  --gray-200: #bfbfbf;
  --gray-300: #a6a6a6;
  --gray-400: #8c8c8c;
  --gray-500: #737373;
  --gray-600: #595959;
  --gray-700: #404040;
  --gray-800: #262626;
  --gray-900: #0d0d0d;

  /* BOX SHADOW */
  --Shadow-1: 0 3px 10px #ccc;
  --Shadow-2: 0 -1px 10px #ccc;
}

/* ===================== Global Styles =========================== */
body {
  /* Replace 'Arial' with your desired font */
  /* font-family: "Inter", sans-serif; */
  font-family: "Open Sans", serif;
}

/* You can also set the font for specific elements */
h1,
h2,
h3,
h4,
h5,
h6 {
  /* font-family: "Lexend", sans-serif; */
  font-family: "Open Sans", serif;
}

p {
  /* font-family: "Inter", sans-serif; */
  font-family: "Open Sans", serif;
}

button {
  /* font-family: "Inter", sans-serif; */
  font-family: "Open Sans", serif;
}

/* ===================== Custom Button =========================== */
.custom-btn-full {
  width: 100%;
}

.custom-outline-btn {
  background-color: white;
  color: black;
  border: 1px solid rgb(66, 66, 66);
}

.custom-outline-btn:hover {
  background-color: whitesmoke;
  border: 1px solid black;
  color: black;
}

.custom-outline-btn:disabled {
  background-color: transparent;
}

/* ===================== Header section =========================== */
.custom-navbar {
  background-color: var(--White-Color);
  border-bottom: 1px solid var(--gray-100);
  /* box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14),
    0px 1px 3px 0px rgba(0, 0, 0, 0.12); */
}

/* ===================== Main section =========================== */

.mainSection {
  margin-left: 75px;
}

.mainContent {
  padding-top: 15px;
}

/* ===================== Auth Box =========================== */
.auth-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-image: radial-gradient(
    circle farthest-corner at 18.7% 37.8%,
    rgba(250, 250, 250, 1) 0%,
    rgba(225, 234, 238, 1) 90%
  );
}

.auth-box {
  padding: 30px;
  border: 1px solid #ced4da;
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 0.822);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s, box-shadow 0.3s;
  width: 500px;
  margin: 0px 10px;
}

.auth-country-codes {
  height: 300px !important;
  overflow: auto !important;
}

/* ===================== Custom Loader =========================== */

.loader-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.877);
  color: var(--primary-400);
  z-index: 9;
}

.page-loader-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: var(--gray-50);
  color: var(--primary-400);
  z-index: 9;
}

/* ========================== dial-pad  ============================== */
@keyframes gradient-border {
  0% {
    background: linear-gradient(white, white) padding-box,
      linear-gradient(to right, rgb(0, 139, 63), rgba(0, 139, 63, 0.767)) border-box;
  }
  50% {
    background: linear-gradient(white, white) padding-box,
      linear-gradient(to right, rgb(0, 139, 63), rgba(0, 139, 63, 0.637)) border-box;
  }
  100% {
    background: linear-gradient(white, white) padding-box,
      linear-gradient(to right, rgba(0, 139, 63, 0.596), rgb(0, 139, 63)) border-box;
  }
}

.draggable-dialpad-box {
  position: absolute !important;
  /* top: 50%;
  left: 50%; */
  /* transform: translate(-50%, -50%); */
  width: 100%;
  height: 100%;
  background-color: white;
  box-shadow: 0px 0px 50px -6px #2448567a;
  border-radius: 10px;
  border: 3px solid #005679;
  z-index: 100000;
}

.calling {
  border: 3px solid transparent;
  background: linear-gradient(white, white) padding-box,
    linear-gradient(to right, rgb(0, 139, 63), rgb(0, 139, 63, 0.637)) border-box;
  animation: gradient-border 1s infinite linear;
}

.dial-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  padding: 7px 15px;
  background-color: rgb(225 225 225);
  width: 100%;
}

.dialpad {
  padding: 5px;
}

.dial-input {
  outline: none;
  box-shadow: none;
  border: none;
  text-align: center;
  font-weight: bold;
}

.dial-input:focus {
  outline: none;
  box-shadow: none;
}

.on {
  color: var(--primary-400);
}

.off {
  color: var(--gray-800);
}

/* ===================== Custom Modal =========================== */

.inputDataSelect {
  font-family: "Lexend Deca", sans-serif;
}
/* .inputDataSelect select{border:0; height:35px; border-bottom:2px solid #e0e0e0; background:none;} */

button.royalGreen {
  background: var(--royal-Green-btn);
  color: var(--White-Color);
  border: 1px solid var(--royal-Green-btn);
  font-weight: 500;
  border-radius: 5px;
  min-width: 150px;
}

button.mainBlue {
  background: var(--main-Blue-btn);
  color: var(--White-Color);
  border: 0px;
  font-weight: 500;
  border-radius: 5px;
  min-width: 150px;
}

button.transParent {
  background: none;
  color: var(--royal-Green-btn);
  border: 1px solid var(--royal-Green-btn);
  font-weight: 500;
  border-radius: 5px;
  min-width: 150px;
}

button.royalGreen:hover {
  color: whitesmoke;
  background-color: var(--royal-Green-hover-btn);
  border: 1px solid var(--royal-Green-disable-btn);
  box-shadow: 1px 1px 7px -1px #808080c2;
}

button.royalGreen:disabled {
  color: whitesmoke;
  background-color: var(--royal-Green-disable-btn);
  border: 1px solid #4a6873;
  box-shadow: none;
}

.inputData.withIcon label {
  left: 48px;
  top: 11px;
  bottom: auto;
}
.inputData.withIcon .form-control {
  padding-left: 48px;
}
.inputData.withIcon .icon {
  position: absolute;
  left: 16px;
  top: 6px;
  font-size: 20px;
  color: #6d8297;
}
.inputData.withIcon label.label {
  font-size: 14px;
  width: auto;
}

.needHelp {
  font-size: 14px;
  color: #494949;
}
.needHelp span {
  font-size: 20px;
  cursor: pointer;
}

.inputData {
  width: 100%;
  height: 45px;
  position: relative;
  font-family: "Lexend Deca", sans-serif;
}
.inputData1 {
  width: 100%;
  height: 195px;
  position: relative;
  font-family: "Lexend Deca", sans-serif;
}
.textareaData {
  height: auto;
}

.inputData input,
.textareaData textarea {
  display: block;
  width: 100%;
  height: 50px;
  padding: 0 10px;
  /* border: none; */
  background: #fff;
  font-size: 17px;
  /* border-bottom: 2px solid rgba(0, 0, 0, 0.12); */
  margin: 0px;
  /* border-radius: 0px; */
  font-family: "Lexend Deca", sans-serif;
}

.inputData input:focus ~ label,
.textareaData textarea:focus ~ label,
.inputData input:valid ~ label,
.textareaData textarea:valid ~ label {
  transform: translateY(-30px);
  left: 16px;
  font-size: 14px;
  background: #fff;
  padding: 2px 10px;
  border-radius: 6px;
}

.textareaData textarea {
  resize: none;
  padding-top: 10px;
}
.inputData label {
  position: absolute;
  color: var(--Rhino-color);
  pointer-events: none;
  bottom: 8px;
  left: 16px;
  font-size: 16px;
  transition: all 0.3s ease;
  font-family: "Lexend Deca", sans-serif;
}
.textareaData label {
  width: 100%;
  bottom: auto;
  top: 10px;
}
.inputData .underline {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 2px;
  width: 100%;
}
.inputData .underline:before {
  content: "";
  position: absolute;
  height: 2px;
  width: 100%;
  left: 0px;
  background: #3498db;
  transform: scaleX(0);
  transform-origin: center;
  transition: transform 0.3s ease;
}

.inputData input:focus ~ .underline:before,
.inputData input:valid ~ .underline:before,
.textareaData textarea:focus ~ .underline:before,
.textareaData textarea:valid ~ .underline:before {
  transform: scale(1);
}

.textareaData textarea:focus-visible {
  outline: none;
}

.composeMail .textareaData .inputData1:focus-visible {
  outline: none;
}
.composeMail .textareaData label {
  width: 100%;
  bottom: auto;
  top: 10px;
  background: none;
}
.composeMail.rightModal .bottomBtn {
  width: 50%;
}

/* .inputData input:focus{background:#FFF;} */
.inputData input:focus-visible {
  outline: none;
}

.inputData.selectForm {
  position: relative;
}

.inputData.selectForm label {
  position: absolute;
  top: -13px;
  left: 16px;
  background: #fff;
  padding: 2px 5px;
  bottom: auto;
  font-size: 14px;
}
.inputData.selectForm .icon {
  position: absolute;
  left: 16px;
  top: 8px;
  font-size: 20px;
  color: #6d8297;
}
.inputData.selectForm .form-select {
  height: 50px;
  padding-left: 48px;
}

.allModal {
  padding: 20px;
  text-align: center;
}

.button-group {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

select.cstSelect {
  border-radius: 0;
  height: 45px;
  border: 0px;
  border-bottom: 2px solid #dcdcde;
  background-color: #f5f6f8;
}
label.cstLAbelSelect {
  font-size: 14px;
  color: var(--Rhino-color);
}

.form-control .css-1jy569b-MuiFormLabel-root-MuiInputLabel-root {
  opacity: 0;
}

.calenderInput .css-5rcoci-MuiStack-root {
  width: 100%;
}
.calenderInput .MuiStack-root {
  margin: 0px;
  padding: 0px;
}
.calenderInput .MuiInputBase-root {
  border-radius: 0px;
  box-shadow: none;
  border-bottom: 2px solid #dcdcde;
  background: #f5f6f8;
}
.calenderInput .MuiInputBase-root input {
  padding: 10px;
}
.calenderInput fieldset {
  display: none;
}

.login_header {
  background: rgb(36 72 86);
  color: var(--White-Color);
  padding: 5px;
  font-size: 14px;
}

.login-button-div button {
  width: 70%;
  padding: 10px;
  background-color: #244856;
}
.tags-container {
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
}
.tags-container .tag {
  border: 1px solid #b5c2da;
  background: #f5f6f8;
  color: #244856;
  font-size: 13px;
  padding: 3px 5px;
  border-radius: 4px;
}
.tags-container .tag > span {
  font-size: 20px;
  padding: 0;
  margin: 0 0 0 10px;
  line-height: 5px;
  cursor: pointer;
}

.login-container {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.rightModal.composeMail {
  width: 50%;
}

.rightModal {
  position: fixed;
  top: 0px;
  right: 0px;
  z-index: 10;
  min-height: 100vh;
  height: 100%;
  width: 400px;
  /* padding-bottom: 80px; */
  overflow: auto;
  background: var(--White-Color);
  box-shadow: var(--Shadow-1);
}
.rightModal .bottomBtn {
  position: fixed;
  background: #fff;
  width: 500px;
  padding: 10px 20px;
  bottom: 0;
  z-index: 9;
  right: 0;
  box-shadow: var(--Shadow-2);
}
.rightModal.composeMail {
  width: 100%;
  padding-left: 76px;
}
.rightModal.composeMail .dashBoxMain {
  padding: 0px;
}
.rightModal.composeMail .pageTitleBlk {
  display: none;
}

.taskModal {
  font-family: "Lexend Deca", sans-serif;
}
.taskModal .modal-header {
  background: var(--primary-400);
  color: var(--White-Color);
}
.taskModal .modal-header h4 {
  font-size: 20px;
}
.taskModal .modal-header .btnClose {
  color: var(--White-Color);
  background: none;
  border: 0;
  font-size: 30px;
  line-height: 20px;
  margin: 0px;
  padding: 0;
}
.taskModal .btnSubmit {
  background: #5544dc;
  color: #fff;
  min-width: 180px;
  border: 2px solid #5544dc;
  border-radius: 0px;
  font-size: 18px;
  border-radius: 10px;
}
.taskModal .btnSubmit:focus,
.taskModal .btnSubmit:hover {
  background: var(--Black-Color);
  border: 2px solid var(--Blue-Dianne);
}

.taskModal .btnNobg {
  background: none;
  color: #302f2f;
  min-width: 180px;
  border: 2px solid #9e9b9b;
  border-radius: 0px;
  font-size: 18px;
  border-radius: 10px;
}
.taskModal .btnNobg:focus,
.taskModal .btnNobg:hover {
  background: var(--White-Color);
  color: var(--Black-Color);
  border: 2px solid var(--Blue-Dianne);
}

.taskModal .h3Title {
  color: var(--Rhino-color);
}

.taskModal .poupTitle h3 {
  font-size: 18px;
  color: #152931;
  font-weight: 500;
}
.taskModal .poupTitle p {
  font-size: 15px;
  color: #2d5a6c;
  font-weight: 400;
}

.taskModal .alredyAcount {
  color: var(--Rhino-color);
  font-size: 15px;
  font-weight: 500;
}
.taskModal .privacy {
  font-size: 14px;
  color: #333;
  font-weight: 300;
}
.taskModal .inputOtp > div {
  gap: 10px;
  text-align: center;
  justify-content: center;
}
.taskModal .inputOtp > div input {
  width: 50px !important;
  height: 50px;
  border: 0px;
  border-bottom: 2px solid #b5c2da;
  background: #f5f6f8;
}
.taskModal .inputOtp > div input:focus,
.taskModal .inputOtp > div input:focus-visible {
  outline: none;
}

.taskModal .fileDownload {
  font-size: 14px;
}
.taskModal .fileDownload a {
  text-decoration: none;
}

.accountButtons a {
  display: flex;
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  align-items: center;
  min-height: 140px;
  justify-content: center;
  color: #000;
  /* text-decoration: none; */
  font-weight: 600;
}

.accountButtons.choosAc {
  width: 100%;
}
.accountButtons.choosAc img {
  width: 100%;
}

.fltrSearch {
  position: relative;
  display: flex;
  align-items: center;
  width: 350px;
}
.fltrSearch input {
  width: 100%;
  border: 1px solid #d5d5d5;
  border-radius: 0;
}
.fltrSearch .serchIcon {
  background: none;
  position: absolute;
  right: 6px;
  border: 0px;
  font-size: 22px;
  top: 0px;
  height: 100%;
  line-height: 20px;
}

.formSelect {
  position: relative;
}
.formSelect .icon {
  position: absolute;
  top: 9px;
  right: 8px;
  color: #058bd3;
  font-size: 20px;
}
.formSelect select {
  border: 0px;
  background: none;
  color: #058bd3;
  width: auto;
  font-weight: 600;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  -o-appearance: none;
}
.formSelect select option {
  background: #fff;
  color: #000;
}

.form-check.checkBox {
  padding: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0px;
  color: var(--Dove-Gray-btn);
  font-weight: 600;
}
.form-check.checkBox .form-check-input {
  height: 22px;
  width: 22px;
  margin: 0px;
  padding: 0;
  border: 2px solid var(--Dove-Gray-btn);
}

.filterBox .resetBtn {
  color: var(--Dove-Gray-btn);
  font-weight: 600;
}

.filterBox.btnAdjust button {
  min-width: auto;
  padding: 8px 15px;
  font-size: 15px;
}

.profilePage .changeEmail {
  background: #f0eeff;
}
.profilePage .changeEmail span {
  font-size: 16px;
  line-height: 18px;
}
.profilePage .changeEmail a {
  color: #080808;
  font-weight: 600;
  font-size: 16px;
}

.profilePage {
  background: var(--White-Color);
  padding: 30px 40px;
  font-family: "Lexend Deca", sans-serif;
}
.profilePage .pickName {
  display: flex;
  align-items: center;
  margin-bottom: 40px;
  padding-bottom: 40px;
  border-bottom: 1px solid #b5c2da;
}
.profilePage .pickName img {
  height: 88px;
  width: 88px;
  border-radius: 100%;
}

.profilePage .subTitle {
  font-size: 18px;
  color: #161616;
  font-weight: 600;
}

.timeFromate {
  font-size: 13px;
  color: #696969;
}

.nameDtl h3 {
  font-size: 18px;
  font-weight: 600;
  color: var(--Blue-Dianne);
}
.nameDtl p {
  font-size: 14px;
  font-weight: 400;
  color: var(--Blue-Dianne);
}

.homepage {
  background: var(--White-Color);
  font-family: "Lexend Deca", sans-serif;
}

.homeBanner h2 {
  font-size: 60px;
  font-weight: 400;
}
.homeBanner h2 > span {
  display: block;
  position: relative;
}
.homeBanner h2 > span::after {
  content: "";
  position: absolute;
  height: 20px;
  z-index: 0;
  width: 100%;
  background: rgba(30, 175, 179, 0.2);
  left: 0px;
  bottom: 0px;
}
.homeBanner p {
  font-size: 20px;
  font-weight: 400;
  padding: 10px 0;
}
.homeBanner button {
  background: var(--Eastern-Blue);
  color: var(--White-Color);
  border: 0px;
  padding: 10px 30px;
  font-size: 18px;
  border-radius: 10px;
}

.patientDr {
  background: var(--section-bg);
}
.patientDr h3 {
  font-size: 36px;
  font-weight: 600;
}
.patientDr p {
  font-size: 16px;
  color: #333;
  line-height: 30px;
}

.ourClient {
  background: var(--section-bg);
}

.clientBox {
  background: #fff;
  padding: 15px;
  border-radius: 5px;
  margin: 0 10px;
}
.clientBox h3 {
  font-size: 20px;
  margin: 0;
}
.clientBox p {
  font-size: 15px;
  font-weight: 300;
  color: #333;
  margin: 0;
}

.account-selection-container {
  text-align: center;
}
.account-buttons {
  width: 100%;
}
.account-button {
  width: 80%;
  max-width: 300px;
  margin: 10px 0;
}
button.btn-primary {
  background-color: #007bff;
  border-color: #007bff;
  color: #fff;
}
button.btn-primary:hover {
  background-color: #0056b3;
  border-color: #004085;
}

/* styles.css */
.pagination {
  display: flex;
  justify-content: center;
  list-style-type: none;
  padding: 0;
  margin: 20px 0;
}
.pagination li {
  margin: 0 5px;
}
.pagination li a {
  padding: 10px 15px;
  border: 1px solid #ddd;
  color: #007bff;
  text-decoration: none;
  cursor: pointer;
  border-radius: 4px;
}
.pagination li a:hover {
  background-color: #f0f0f0;
}
.pagination li.active a {
  background-color: #007bff;
  color: white;
  border-color: #007bff;
}
.pagination li.disabled a {
  color: #ccc;
  cursor: not-allowed;
}

.form-check .form-check-input {
  height: 25px;
  width: 25px;
  margin-top: -1px;
  margin-right: 8px;
  border: 2px solid var(--Casal-color);
}
.form-check .form-check-input:checked {
  background-color: var(--Casal-color);
  border-color: var(--Casal-color);
}

.cstTab {
  border-bottom: 1px solid #b5c2da;
  display: flex;
  gap: 20px;
  padding: 0px;
}
.cstTab li {
  padding: 10px 20px;
  background: #fff;
  border-radius: 10px 10px 0 0;
  border: 1px solid #b5c2da;
  min-width: 200px;
  margin-bottom: -1px;
  opacity: 0.5;
  cursor: pointer;
}
.cstTab li.active {
  opacity: 1;
}

.cstTab.posTab {
  display: inline-flex;
  background: #eaeaea;
  gap: 0;
  border: 0;
  border-radius: 10px 10px 0 0;
  overflow: hidden;
}
.cstTab.posTab li {
  min-width: auto;
  border: 0;
  opacity: 1;
  border-radius: 0;
  background: none;
}

.cstTab.posTab li.active {
  background: #058bd3;
  color: #fff;
  border-radius: 10px 10px 0 0;
}

.pagination li.disabled a {
  color: #ccc;
  cursor: not-allowed;
}

/* ===================== Page Title =========================== */
.pageTitle1 {
  background: var(--White-Color);
}
.pageTitle1 h3 {
  font-size: 24px;
  color: #000;
  font-weight: 600;
}
.pageTitle1 p {
  font-size: 14px;
  color: #000;
}

.rightModal.changeEmail {
  background: #f2f2f2;
}
.changeEmail .lgIcon {
  font-size: 50px;
}
.changeEmail h3 {
  font-size: 20px;
  font-weight: 600;
}
.changeEmail p {
  font-size: 16px;
  color: #3c4248;
}
.taskModal.changeEmail .btnNobg,
.taskModal.changeEmail .btnSubmit {
  min-width: 150px;
}

.taskModal.changeEmail .btnNobg {
  background: #fff;
  border: 1px solid #9e9b9b;
}
.taskModal.changeEmail .btnSubmit {
  background: #5544dc;
  border: 1px solid #5544dc;
}

.taskModal.changeEmail .resend span {
  font-size: 24px;
}

.taskModal.changeEmail .resend {
  color: #5544dc;
  font-size: 17px;
  font-weight: 600;
  text-decoration: none;
  display: flex;
  justify-content: center;
  align-items: center;
}

.withIcon {
  position: relative;
}
.withIcon .icon {
  position: absolute;
  left: 14px;
  top: 8px;
  font-size: 20px;
  color: #6d8297;
}
.withIcon .form-control {
  height: 46px;
  padding-left: 45px;
}

.transparentBtn button {
  background: #fff;
  border: 1px solid #000;
  border-radius: 30px;
  padding: 4px 10px 6px;
  font-size: 14px;
  width: 130px;
}
.transparentBtn button span {
  font-size: 18px;
  line-height: 22px;
}
.transparentBtn button.active {
  border: 1px solid var(--primary-400);
  color: var(--primary-400);
  font-weight: 600;
}

.privacyPolicy h1 {
  font-size: 32px;
  font-weight: 700;
  color: #000;
}
.privacyPolicy h2 {
  font-size: 26px;
  font-weight: 700;
  color: #000;
}

.contactForm .form-group label {
  margin-bottom: 5px;
}

.contactForm .form-control {
  height: 50px;
}

.contact .heading h2 {
  font-size: 30px;
  font-weight: 700;
  margin: 0;
  padding: 0;
}

.contact .heading h2 span {
  color: #ff9100;
}

.contact .heading p {
  font-size: 16px;
  font-weight: 400;
  line-height: 1.7;
  color: #212529;
  margin: 20px 0;
  padding: 0;
}

.contact .title h3,
.contentPage h3 {
  font-weight: 600;
  font-size: 20px;
}

.contactDetail {
  border-top: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
}

.contactDetail h3 {
  margin-bottom: 15px;
}

.contact .form-control {
  padding: 15px 25px;
  font-size: 16px;
  margin-bottom: 20px;
  background: #f4f4f4;
  border: 1px solid #e9e9e9;
  border-radius: 10px;
  margin-top: 10px;
}

.contact .title p {
  font-size: 14px;
  font-weight: 400;
  color: #999;
  line-height: 1.6;
  margin: 0 0 40px;
}

.contact .content .info i {
  font-size: 30px;
  padding: 0;
  margin: 0 20px 0 0;
  color: #0f417b;
  text-align: center;
  width: 20px;
  vertical-align: super;
}

.contact .content .info h4 {
  font-size: 14px;
  line-height: 1.4;
  color: #3b3b3b;
}

.contact .content .info h4 span {
  font-size: 16px;
  font-weight: 400;
  color: #212529;
}

.contentPage h3 {
  margin-bottom: 10px;
}

.contentPage h2 {
  font-size: 22px;
  font-weight: 500;
  margin: 20px 0 10px;
}

.contentPage h5,
.contentPage p,
.contentPage ul li {
  margin-bottom: 10px;
}

.contentPage h5 {
  font-weight: 500;
  font-size: 18px;
}

.contentPage ul {
  margin: 0 0 10px;
  padding-left: 20px;
}

.contentPage ul li {
  list-style: square;
  line-height: 22px;
}

.innerHeader {
  background: #f8f9fa;
}

.contact,
.innerHeader {
  padding: 50px 0;
}

.contact .content .info,
a.home-btn {
  margin-top: 30px;
}

.heading h2 {
  font-size: 2rem;
  margin-bottom: 15px;
}

.contactDetail .info {
  text-align: center;
  margin-bottom: 20px;
}

.info h4 {
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,8DAA8D;AAC9D,oOAAoO;;AAKpO,gEAAgE;;AAEhE;EACE,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;;EAEnB,kBAAkB;EAClB,wBAAwB;EACxB,0BAA0B;EAC1B,oCAAoC;EACpC,gCAAgC;EAChC,wBAAwB;EACxB,uBAAuB;;EAEvB,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;;EAEtB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;;EAEnB,eAAe;EACf,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA,oEAAoE;AACpE;EACE,2CAA2C;EAC3C,sCAAsC;EACtC,+BAA+B;AACjC;;AAEA,oDAAoD;AACpD;;;;;;EAME,uCAAuC;EACvC,+BAA+B;AACjC;;AAEA;EACE,sCAAsC;EACtC,+BAA+B;AACjC;;AAEA;EACE,sCAAsC;EACtC,+BAA+B;AACjC;;AAEA,oEAAoE;AACpE;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,4BAA4B;EAC5B,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,qEAAqE;AACrE;EACE,oCAAoC;EACpC,wCAAwC;EACxC;0CACwC;AAC1C;;AAEA,mEAAmE;;AAEnE;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb;;;;GAIC;AACH;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,4CAA4C;EAC5C,wCAAwC;EACxC,2CAA2C;EAC3C,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA,oEAAoE;;AAEpE;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,4CAA4C;EAC5C,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,gCAAgC;EAChC,yBAAyB;EACzB,UAAU;AACZ;;AAEA,wEAAwE;AACxE;EACE;IACE;oFACgF;EAClF;EACA;IACE;oFACgF;EAClF;EACA;IACE;oFACgF;EAClF;AACF;;AAEA;EACE,6BAA6B;EAC7B;cACY;EACZ,sCAAsC;EACtC,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,uCAAuC;EACvC,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B;iFAC+E;EAC/E,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,4BAA4B;EAC5B,6BAA6B;EAC7B,iBAAiB;EACjB,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA,mEAAmE;;AAEnE;EACE,sCAAsC;AACxC;AACA,sGAAsG;;AAEtG;EACE,kCAAkC;EAClC,yBAAyB;EACzB,wCAAwC;EACxC,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,wCAAwC;EACxC,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,8CAA8C;EAC9C,gDAAgD;EAChD,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;EACjB,gDAAgD;EAChD,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EACE,YAAY;AACd;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kDAAkD;EAClD,WAAW;EACX,wBAAwB;EACxB,sCAAsC;AACxC;;AAEA;;;;EAIE,4BAA4B;EAC5B,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,oBAAoB;EACpB,WAAW;EACX,UAAU;EACV,eAAe;EACf,yBAAyB;EACzB,sCAAsC;AACxC;AACA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;AACb;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA;;;;EAIE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,UAAU;AACZ;;AAEA,6CAA6C;AAC7C;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,gCAAgC;EAChC,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,YAAY;EACZ,0BAA0B;EAC1B,cAAc;EACd,8BAA8B;EAC9B,2BAA2B;AAC7B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,QAAQ;EACR,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;;AAEA;EACE,sCAAsC;AACxC;AACA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;AACA;EACE,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;AACA;;EAEE,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;AACA;;EAEE,8BAA8B;EAC9B,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,gCAAgC;EAChC,mBAAmB;AACrB;AACA;;EAEE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,uCAAuC;EACvC,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;EACvB,WAAW;EACX,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,cAAc;EACd,eAAe;AACjB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,WAAW;EACX,WAAW;EACX,UAAU;EACV,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;AACA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,WAAW;EACX,mCAAmC;EACnC,SAAS;EACT,WAAW;AACb;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,eAAe;EACf,SAAS;AACX;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;EACV,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,UAAU;EACV,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,oCAAoC;AACtC;AACA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,aAAa;EACb,SAAS;EACT,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,MAAM;EACN,SAAS;EACT,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA,iEAAiE;AACjE;EACE,8BAA8B;AAChC;AACA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,YAAY;AACd;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,UAAU;AACZ;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX","sourcesContent":["/* ===================== Imports =========================== */\r\n/* @import url(\"https://fonts.googleapis.com/css2?family=Lexend:wght@100..900&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\"); */\r\n@import url(\"https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=Lexend:wght@100..900&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\r\n\r\n@import url(\"https://fonts.googleapis.com/css2?family=Open+Sans:ital,wdth,wght@0,75..100,300..800;1,75..100,300..800&display=swap\");\r\n\r\n/* ===================== Variables =========================== */\r\n\r\n:root {\r\n  --Blue-Dianne: #2b2d42;\r\n  --Rhino-color: #2d455d;\r\n  --Casal-Color: #8d99ae;\r\n  --White-Color: #fff;\r\n  --Black-Color: #000;\r\n  --section-bg: #f5f5f5;\r\n  --nobel-bg: #b5b5b5;\r\n\r\n  /* Buttons Color */\r\n  --main-Blue-btn: #058bd3;\r\n  --royal-Green-btn: #244856;\r\n  --royal-Green-disable-btn: #244856d3;\r\n  --royal-Green-hover-btn: #1e3c47;\r\n  --Dove-Gray-btn: #727272;\r\n  --Eastern-Blue: #1eafb3;\r\n\r\n  /* Theme Color */\r\n  --primary-50: #eae9ff;\r\n  --primary-100: #c4bef8;\r\n  --primary-200: #9d94ed;\r\n  --primary-300: #7669e4;\r\n  --primary-400: #4f3edb;\r\n  --primary-500: #3624c1;\r\n  --primary-600: #291c97;\r\n  --primary-700: #1d136d;\r\n  --primary-800: #100b43;\r\n  --primary-900: #06031c;\r\n\r\n  /* Dark Shades */\r\n  --gray-50: #f2f2f2;\r\n  --gray-100: #d9d9d9;\r\n  --gray-200: #bfbfbf;\r\n  --gray-300: #a6a6a6;\r\n  --gray-400: #8c8c8c;\r\n  --gray-500: #737373;\r\n  --gray-600: #595959;\r\n  --gray-700: #404040;\r\n  --gray-800: #262626;\r\n  --gray-900: #0d0d0d;\r\n\r\n  /* BOX SHADOW */\r\n  --Shadow-1: 0 3px 10px #ccc;\r\n  --Shadow-2: 0 -1px 10px #ccc;\r\n}\r\n\r\n/* ===================== Global Styles =========================== */\r\nbody {\r\n  /* Replace 'Arial' with your desired font */\r\n  /* font-family: \"Inter\", sans-serif; */\r\n  font-family: \"Open Sans\", serif;\r\n}\r\n\r\n/* You can also set the font for specific elements */\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6 {\r\n  /* font-family: \"Lexend\", sans-serif; */\r\n  font-family: \"Open Sans\", serif;\r\n}\r\n\r\np {\r\n  /* font-family: \"Inter\", sans-serif; */\r\n  font-family: \"Open Sans\", serif;\r\n}\r\n\r\nbutton {\r\n  /* font-family: \"Inter\", sans-serif; */\r\n  font-family: \"Open Sans\", serif;\r\n}\r\n\r\n/* ===================== Custom Button =========================== */\r\n.custom-btn-full {\r\n  width: 100%;\r\n}\r\n\r\n.custom-outline-btn {\r\n  background-color: white;\r\n  color: black;\r\n  border: 1px solid rgb(66, 66, 66);\r\n}\r\n\r\n.custom-outline-btn:hover {\r\n  background-color: whitesmoke;\r\n  border: 1px solid black;\r\n  color: black;\r\n}\r\n\r\n.custom-outline-btn:disabled {\r\n  background-color: transparent;\r\n}\r\n\r\n/* ===================== Header section =========================== */\r\n.custom-navbar {\r\n  background-color: var(--White-Color);\r\n  border-bottom: 1px solid var(--gray-100);\r\n  /* box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14),\r\n    0px 1px 3px 0px rgba(0, 0, 0, 0.12); */\r\n}\r\n\r\n/* ===================== Main section =========================== */\r\n\r\n.mainSection {\r\n  margin-left: 75px;\r\n}\r\n\r\n.mainContent {\r\n  padding-top: 15px;\r\n}\r\n\r\n/* ===================== Auth Box =========================== */\r\n.auth-container {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  height: 100vh;\r\n  background-image: radial-gradient(\r\n    circle farthest-corner at 18.7% 37.8%,\r\n    rgba(250, 250, 250, 1) 0%,\r\n    rgba(225, 234, 238, 1) 90%\r\n  );\r\n}\r\n\r\n.auth-box {\r\n  padding: 30px;\r\n  border: 1px solid #ced4da;\r\n  border-radius: 10px;\r\n  background-color: rgba(255, 255, 255, 0.822);\r\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\r\n  transition: transform 0.3s, box-shadow 0.3s;\r\n  width: 500px;\r\n  margin: 0px 10px;\r\n}\r\n\r\n.auth-country-codes {\r\n  height: 300px !important;\r\n  overflow: auto !important;\r\n}\r\n\r\n/* ===================== Custom Loader =========================== */\r\n\r\n.loader-container {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  background-color: rgba(255, 255, 255, 0.877);\r\n  color: var(--primary-400);\r\n  z-index: 9;\r\n}\r\n\r\n.page-loader-container {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  background-color: var(--gray-50);\r\n  color: var(--primary-400);\r\n  z-index: 9;\r\n}\r\n\r\n/* ========================== dial-pad  ============================== */\r\n@keyframes gradient-border {\r\n  0% {\r\n    background: linear-gradient(white, white) padding-box,\r\n      linear-gradient(to right, rgb(0, 139, 63), rgba(0, 139, 63, 0.767)) border-box;\r\n  }\r\n  50% {\r\n    background: linear-gradient(white, white) padding-box,\r\n      linear-gradient(to right, rgb(0, 139, 63), rgba(0, 139, 63, 0.637)) border-box;\r\n  }\r\n  100% {\r\n    background: linear-gradient(white, white) padding-box,\r\n      linear-gradient(to right, rgba(0, 139, 63, 0.596), rgb(0, 139, 63)) border-box;\r\n  }\r\n}\r\n\r\n.draggable-dialpad-box {\r\n  position: absolute !important;\r\n  /* top: 50%;\r\n  left: 50%; */\r\n  /* transform: translate(-50%, -50%); */\r\n  width: 100%;\r\n  height: 100%;\r\n  background-color: white;\r\n  box-shadow: 0px 0px 50px -6px #2448567a;\r\n  border-radius: 10px;\r\n  border: 3px solid #005679;\r\n  z-index: 100000;\r\n}\r\n\r\n.calling {\r\n  border: 3px solid transparent;\r\n  background: linear-gradient(white, white) padding-box,\r\n    linear-gradient(to right, rgb(0, 139, 63), rgb(0, 139, 63, 0.637)) border-box;\r\n  animation: gradient-border 1s infinite linear;\r\n}\r\n\r\n.dial-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  border-top-left-radius: 10px;\r\n  border-top-right-radius: 10px;\r\n  padding: 7px 15px;\r\n  background-color: rgb(225 225 225);\r\n  width: 100%;\r\n}\r\n\r\n.dialpad {\r\n  padding: 5px;\r\n}\r\n\r\n.dial-input {\r\n  outline: none;\r\n  box-shadow: none;\r\n  border: none;\r\n  text-align: center;\r\n  font-weight: bold;\r\n}\r\n\r\n.dial-input:focus {\r\n  outline: none;\r\n  box-shadow: none;\r\n}\r\n\r\n.on {\r\n  color: var(--primary-400);\r\n}\r\n\r\n.off {\r\n  color: var(--gray-800);\r\n}\r\n\r\n/* ===================== Custom Modal =========================== */\r\n\r\n.inputDataSelect {\r\n  font-family: \"Lexend Deca\", sans-serif;\r\n}\r\n/* .inputDataSelect select{border:0; height:35px; border-bottom:2px solid #e0e0e0; background:none;} */\r\n\r\nbutton.royalGreen {\r\n  background: var(--royal-Green-btn);\r\n  color: var(--White-Color);\r\n  border: 1px solid var(--royal-Green-btn);\r\n  font-weight: 500;\r\n  border-radius: 5px;\r\n  min-width: 150px;\r\n}\r\n\r\nbutton.mainBlue {\r\n  background: var(--main-Blue-btn);\r\n  color: var(--White-Color);\r\n  border: 0px;\r\n  font-weight: 500;\r\n  border-radius: 5px;\r\n  min-width: 150px;\r\n}\r\n\r\nbutton.transParent {\r\n  background: none;\r\n  color: var(--royal-Green-btn);\r\n  border: 1px solid var(--royal-Green-btn);\r\n  font-weight: 500;\r\n  border-radius: 5px;\r\n  min-width: 150px;\r\n}\r\n\r\nbutton.royalGreen:hover {\r\n  color: whitesmoke;\r\n  background-color: var(--royal-Green-hover-btn);\r\n  border: 1px solid var(--royal-Green-disable-btn);\r\n  box-shadow: 1px 1px 7px -1px #808080c2;\r\n}\r\n\r\nbutton.royalGreen:disabled {\r\n  color: whitesmoke;\r\n  background-color: var(--royal-Green-disable-btn);\r\n  border: 1px solid #4a6873;\r\n  box-shadow: none;\r\n}\r\n\r\n.inputData.withIcon label {\r\n  left: 48px;\r\n  top: 11px;\r\n  bottom: auto;\r\n}\r\n.inputData.withIcon .form-control {\r\n  padding-left: 48px;\r\n}\r\n.inputData.withIcon .icon {\r\n  position: absolute;\r\n  left: 16px;\r\n  top: 6px;\r\n  font-size: 20px;\r\n  color: #6d8297;\r\n}\r\n.inputData.withIcon label.label {\r\n  font-size: 14px;\r\n  width: auto;\r\n}\r\n\r\n.needHelp {\r\n  font-size: 14px;\r\n  color: #494949;\r\n}\r\n.needHelp span {\r\n  font-size: 20px;\r\n  cursor: pointer;\r\n}\r\n\r\n.inputData {\r\n  width: 100%;\r\n  height: 45px;\r\n  position: relative;\r\n  font-family: \"Lexend Deca\", sans-serif;\r\n}\r\n.inputData1 {\r\n  width: 100%;\r\n  height: 195px;\r\n  position: relative;\r\n  font-family: \"Lexend Deca\", sans-serif;\r\n}\r\n.textareaData {\r\n  height: auto;\r\n}\r\n\r\n.inputData input,\r\n.textareaData textarea {\r\n  display: block;\r\n  width: 100%;\r\n  height: 50px;\r\n  padding: 0 10px;\r\n  /* border: none; */\r\n  background: #fff;\r\n  font-size: 17px;\r\n  /* border-bottom: 2px solid rgba(0, 0, 0, 0.12); */\r\n  margin: 0px;\r\n  /* border-radius: 0px; */\r\n  font-family: \"Lexend Deca\", sans-serif;\r\n}\r\n\r\n.inputData input:focus ~ label,\r\n.textareaData textarea:focus ~ label,\r\n.inputData input:valid ~ label,\r\n.textareaData textarea:valid ~ label {\r\n  transform: translateY(-30px);\r\n  left: 16px;\r\n  font-size: 14px;\r\n  background: #fff;\r\n  padding: 2px 10px;\r\n  border-radius: 6px;\r\n}\r\n\r\n.textareaData textarea {\r\n  resize: none;\r\n  padding-top: 10px;\r\n}\r\n.inputData label {\r\n  position: absolute;\r\n  color: var(--Rhino-color);\r\n  pointer-events: none;\r\n  bottom: 8px;\r\n  left: 16px;\r\n  font-size: 16px;\r\n  transition: all 0.3s ease;\r\n  font-family: \"Lexend Deca\", sans-serif;\r\n}\r\n.textareaData label {\r\n  width: 100%;\r\n  bottom: auto;\r\n  top: 10px;\r\n}\r\n.inputData .underline {\r\n  position: absolute;\r\n  bottom: 0;\r\n  left: 0;\r\n  height: 2px;\r\n  width: 100%;\r\n}\r\n.inputData .underline:before {\r\n  content: \"\";\r\n  position: absolute;\r\n  height: 2px;\r\n  width: 100%;\r\n  left: 0px;\r\n  background: #3498db;\r\n  transform: scaleX(0);\r\n  transform-origin: center;\r\n  transition: transform 0.3s ease;\r\n}\r\n\r\n.inputData input:focus ~ .underline:before,\r\n.inputData input:valid ~ .underline:before,\r\n.textareaData textarea:focus ~ .underline:before,\r\n.textareaData textarea:valid ~ .underline:before {\r\n  transform: scale(1);\r\n}\r\n\r\n.textareaData textarea:focus-visible {\r\n  outline: none;\r\n}\r\n\r\n.composeMail .textareaData .inputData1:focus-visible {\r\n  outline: none;\r\n}\r\n.composeMail .textareaData label {\r\n  width: 100%;\r\n  bottom: auto;\r\n  top: 10px;\r\n  background: none;\r\n}\r\n.composeMail.rightModal .bottomBtn {\r\n  width: 50%;\r\n}\r\n\r\n/* .inputData input:focus{background:#FFF;} */\r\n.inputData input:focus-visible {\r\n  outline: none;\r\n}\r\n\r\n.inputData.selectForm {\r\n  position: relative;\r\n}\r\n\r\n.inputData.selectForm label {\r\n  position: absolute;\r\n  top: -13px;\r\n  left: 16px;\r\n  background: #fff;\r\n  padding: 2px 5px;\r\n  bottom: auto;\r\n  font-size: 14px;\r\n}\r\n.inputData.selectForm .icon {\r\n  position: absolute;\r\n  left: 16px;\r\n  top: 8px;\r\n  font-size: 20px;\r\n  color: #6d8297;\r\n}\r\n.inputData.selectForm .form-select {\r\n  height: 50px;\r\n  padding-left: 48px;\r\n}\r\n\r\n.allModal {\r\n  padding: 20px;\r\n  text-align: center;\r\n}\r\n\r\n.button-group {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  margin-top: 20px;\r\n}\r\n\r\nselect.cstSelect {\r\n  border-radius: 0;\r\n  height: 45px;\r\n  border: 0px;\r\n  border-bottom: 2px solid #dcdcde;\r\n  background-color: #f5f6f8;\r\n}\r\nlabel.cstLAbelSelect {\r\n  font-size: 14px;\r\n  color: var(--Rhino-color);\r\n}\r\n\r\n.form-control .css-1jy569b-MuiFormLabel-root-MuiInputLabel-root {\r\n  opacity: 0;\r\n}\r\n\r\n.calenderInput .css-5rcoci-MuiStack-root {\r\n  width: 100%;\r\n}\r\n.calenderInput .MuiStack-root {\r\n  margin: 0px;\r\n  padding: 0px;\r\n}\r\n.calenderInput .MuiInputBase-root {\r\n  border-radius: 0px;\r\n  box-shadow: none;\r\n  border-bottom: 2px solid #dcdcde;\r\n  background: #f5f6f8;\r\n}\r\n.calenderInput .MuiInputBase-root input {\r\n  padding: 10px;\r\n}\r\n.calenderInput fieldset {\r\n  display: none;\r\n}\r\n\r\n.login_header {\r\n  background: rgb(36 72 86);\r\n  color: var(--White-Color);\r\n  padding: 5px;\r\n  font-size: 14px;\r\n}\r\n\r\n.login-button-div button {\r\n  width: 70%;\r\n  padding: 10px;\r\n  background-color: #244856;\r\n}\r\n.tags-container {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  margin-top: 10px;\r\n}\r\n.tags-container .tag {\r\n  border: 1px solid #b5c2da;\r\n  background: #f5f6f8;\r\n  color: #244856;\r\n  font-size: 13px;\r\n  padding: 3px 5px;\r\n  border-radius: 4px;\r\n}\r\n.tags-container .tag > span {\r\n  font-size: 20px;\r\n  padding: 0;\r\n  margin: 0 0 0 10px;\r\n  line-height: 5px;\r\n  cursor: pointer;\r\n}\r\n\r\n.login-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-end;\r\n}\r\n\r\n.rightModal.composeMail {\r\n  width: 50%;\r\n}\r\n\r\n.rightModal {\r\n  position: fixed;\r\n  top: 0px;\r\n  right: 0px;\r\n  z-index: 10;\r\n  min-height: 100vh;\r\n  height: 100%;\r\n  width: 400px;\r\n  /* padding-bottom: 80px; */\r\n  overflow: auto;\r\n  background: var(--White-Color);\r\n  box-shadow: var(--Shadow-1);\r\n}\r\n.rightModal .bottomBtn {\r\n  position: fixed;\r\n  background: #fff;\r\n  width: 500px;\r\n  padding: 10px 20px;\r\n  bottom: 0;\r\n  z-index: 9;\r\n  right: 0;\r\n  box-shadow: var(--Shadow-2);\r\n}\r\n.rightModal.composeMail {\r\n  width: 100%;\r\n  padding-left: 76px;\r\n}\r\n.rightModal.composeMail .dashBoxMain {\r\n  padding: 0px;\r\n}\r\n.rightModal.composeMail .pageTitleBlk {\r\n  display: none;\r\n}\r\n\r\n.taskModal {\r\n  font-family: \"Lexend Deca\", sans-serif;\r\n}\r\n.taskModal .modal-header {\r\n  background: var(--primary-400);\r\n  color: var(--White-Color);\r\n}\r\n.taskModal .modal-header h4 {\r\n  font-size: 20px;\r\n}\r\n.taskModal .modal-header .btnClose {\r\n  color: var(--White-Color);\r\n  background: none;\r\n  border: 0;\r\n  font-size: 30px;\r\n  line-height: 20px;\r\n  margin: 0px;\r\n  padding: 0;\r\n}\r\n.taskModal .btnSubmit {\r\n  background: #5544dc;\r\n  color: #fff;\r\n  min-width: 180px;\r\n  border: 2px solid #5544dc;\r\n  border-radius: 0px;\r\n  font-size: 18px;\r\n  border-radius: 10px;\r\n}\r\n.taskModal .btnSubmit:focus,\r\n.taskModal .btnSubmit:hover {\r\n  background: var(--Black-Color);\r\n  border: 2px solid var(--Blue-Dianne);\r\n}\r\n\r\n.taskModal .btnNobg {\r\n  background: none;\r\n  color: #302f2f;\r\n  min-width: 180px;\r\n  border: 2px solid #9e9b9b;\r\n  border-radius: 0px;\r\n  font-size: 18px;\r\n  border-radius: 10px;\r\n}\r\n.taskModal .btnNobg:focus,\r\n.taskModal .btnNobg:hover {\r\n  background: var(--White-Color);\r\n  color: var(--Black-Color);\r\n  border: 2px solid var(--Blue-Dianne);\r\n}\r\n\r\n.taskModal .h3Title {\r\n  color: var(--Rhino-color);\r\n}\r\n\r\n.taskModal .poupTitle h3 {\r\n  font-size: 18px;\r\n  color: #152931;\r\n  font-weight: 500;\r\n}\r\n.taskModal .poupTitle p {\r\n  font-size: 15px;\r\n  color: #2d5a6c;\r\n  font-weight: 400;\r\n}\r\n\r\n.taskModal .alredyAcount {\r\n  color: var(--Rhino-color);\r\n  font-size: 15px;\r\n  font-weight: 500;\r\n}\r\n.taskModal .privacy {\r\n  font-size: 14px;\r\n  color: #333;\r\n  font-weight: 300;\r\n}\r\n.taskModal .inputOtp > div {\r\n  gap: 10px;\r\n  text-align: center;\r\n  justify-content: center;\r\n}\r\n.taskModal .inputOtp > div input {\r\n  width: 50px !important;\r\n  height: 50px;\r\n  border: 0px;\r\n  border-bottom: 2px solid #b5c2da;\r\n  background: #f5f6f8;\r\n}\r\n.taskModal .inputOtp > div input:focus,\r\n.taskModal .inputOtp > div input:focus-visible {\r\n  outline: none;\r\n}\r\n\r\n.taskModal .fileDownload {\r\n  font-size: 14px;\r\n}\r\n.taskModal .fileDownload a {\r\n  text-decoration: none;\r\n}\r\n\r\n.accountButtons a {\r\n  display: flex;\r\n  background: #fff;\r\n  border-radius: 20px;\r\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);\r\n  overflow: hidden;\r\n  align-items: center;\r\n  min-height: 140px;\r\n  justify-content: center;\r\n  color: #000;\r\n  /* text-decoration: none; */\r\n  font-weight: 600;\r\n}\r\n\r\n.accountButtons.choosAc {\r\n  width: 100%;\r\n}\r\n.accountButtons.choosAc img {\r\n  width: 100%;\r\n}\r\n\r\n.fltrSearch {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n  width: 350px;\r\n}\r\n.fltrSearch input {\r\n  width: 100%;\r\n  border: 1px solid #d5d5d5;\r\n  border-radius: 0;\r\n}\r\n.fltrSearch .serchIcon {\r\n  background: none;\r\n  position: absolute;\r\n  right: 6px;\r\n  border: 0px;\r\n  font-size: 22px;\r\n  top: 0px;\r\n  height: 100%;\r\n  line-height: 20px;\r\n}\r\n\r\n.formSelect {\r\n  position: relative;\r\n}\r\n.formSelect .icon {\r\n  position: absolute;\r\n  top: 9px;\r\n  right: 8px;\r\n  color: #058bd3;\r\n  font-size: 20px;\r\n}\r\n.formSelect select {\r\n  border: 0px;\r\n  background: none;\r\n  color: #058bd3;\r\n  width: auto;\r\n  font-weight: 600;\r\n  appearance: none;\r\n  -webkit-appearance: none;\r\n  -moz-appearance: none;\r\n  -o-appearance: none;\r\n}\r\n.formSelect select option {\r\n  background: #fff;\r\n  color: #000;\r\n}\r\n\r\n.form-check.checkBox {\r\n  padding: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  margin: 0px;\r\n  color: var(--Dove-Gray-btn);\r\n  font-weight: 600;\r\n}\r\n.form-check.checkBox .form-check-input {\r\n  height: 22px;\r\n  width: 22px;\r\n  margin: 0px;\r\n  padding: 0;\r\n  border: 2px solid var(--Dove-Gray-btn);\r\n}\r\n\r\n.filterBox .resetBtn {\r\n  color: var(--Dove-Gray-btn);\r\n  font-weight: 600;\r\n}\r\n\r\n.filterBox.btnAdjust button {\r\n  min-width: auto;\r\n  padding: 8px 15px;\r\n  font-size: 15px;\r\n}\r\n\r\n.profilePage .changeEmail {\r\n  background: #f0eeff;\r\n}\r\n.profilePage .changeEmail span {\r\n  font-size: 16px;\r\n  line-height: 18px;\r\n}\r\n.profilePage .changeEmail a {\r\n  color: #080808;\r\n  font-weight: 600;\r\n  font-size: 16px;\r\n}\r\n\r\n.profilePage {\r\n  background: var(--White-Color);\r\n  padding: 30px 40px;\r\n  font-family: \"Lexend Deca\", sans-serif;\r\n}\r\n.profilePage .pickName {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-bottom: 40px;\r\n  padding-bottom: 40px;\r\n  border-bottom: 1px solid #b5c2da;\r\n}\r\n.profilePage .pickName img {\r\n  height: 88px;\r\n  width: 88px;\r\n  border-radius: 100%;\r\n}\r\n\r\n.profilePage .subTitle {\r\n  font-size: 18px;\r\n  color: #161616;\r\n  font-weight: 600;\r\n}\r\n\r\n.timeFromate {\r\n  font-size: 13px;\r\n  color: #696969;\r\n}\r\n\r\n.nameDtl h3 {\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n  color: var(--Blue-Dianne);\r\n}\r\n.nameDtl p {\r\n  font-size: 14px;\r\n  font-weight: 400;\r\n  color: var(--Blue-Dianne);\r\n}\r\n\r\n.homepage {\r\n  background: var(--White-Color);\r\n  font-family: \"Lexend Deca\", sans-serif;\r\n}\r\n\r\n.homeBanner h2 {\r\n  font-size: 60px;\r\n  font-weight: 400;\r\n}\r\n.homeBanner h2 > span {\r\n  display: block;\r\n  position: relative;\r\n}\r\n.homeBanner h2 > span::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  height: 20px;\r\n  z-index: 0;\r\n  width: 100%;\r\n  background: rgba(30, 175, 179, 0.2);\r\n  left: 0px;\r\n  bottom: 0px;\r\n}\r\n.homeBanner p {\r\n  font-size: 20px;\r\n  font-weight: 400;\r\n  padding: 10px 0;\r\n}\r\n.homeBanner button {\r\n  background: var(--Eastern-Blue);\r\n  color: var(--White-Color);\r\n  border: 0px;\r\n  padding: 10px 30px;\r\n  font-size: 18px;\r\n  border-radius: 10px;\r\n}\r\n\r\n.patientDr {\r\n  background: var(--section-bg);\r\n}\r\n.patientDr h3 {\r\n  font-size: 36px;\r\n  font-weight: 600;\r\n}\r\n.patientDr p {\r\n  font-size: 16px;\r\n  color: #333;\r\n  line-height: 30px;\r\n}\r\n\r\n.ourClient {\r\n  background: var(--section-bg);\r\n}\r\n\r\n.clientBox {\r\n  background: #fff;\r\n  padding: 15px;\r\n  border-radius: 5px;\r\n  margin: 0 10px;\r\n}\r\n.clientBox h3 {\r\n  font-size: 20px;\r\n  margin: 0;\r\n}\r\n.clientBox p {\r\n  font-size: 15px;\r\n  font-weight: 300;\r\n  color: #333;\r\n  margin: 0;\r\n}\r\n\r\n.account-selection-container {\r\n  text-align: center;\r\n}\r\n.account-buttons {\r\n  width: 100%;\r\n}\r\n.account-button {\r\n  width: 80%;\r\n  max-width: 300px;\r\n  margin: 10px 0;\r\n}\r\nbutton.btn-primary {\r\n  background-color: #007bff;\r\n  border-color: #007bff;\r\n  color: #fff;\r\n}\r\nbutton.btn-primary:hover {\r\n  background-color: #0056b3;\r\n  border-color: #004085;\r\n}\r\n\r\n/* styles.css */\r\n.pagination {\r\n  display: flex;\r\n  justify-content: center;\r\n  list-style-type: none;\r\n  padding: 0;\r\n  margin: 20px 0;\r\n}\r\n.pagination li {\r\n  margin: 0 5px;\r\n}\r\n.pagination li a {\r\n  padding: 10px 15px;\r\n  border: 1px solid #ddd;\r\n  color: #007bff;\r\n  text-decoration: none;\r\n  cursor: pointer;\r\n  border-radius: 4px;\r\n}\r\n.pagination li a:hover {\r\n  background-color: #f0f0f0;\r\n}\r\n.pagination li.active a {\r\n  background-color: #007bff;\r\n  color: white;\r\n  border-color: #007bff;\r\n}\r\n.pagination li.disabled a {\r\n  color: #ccc;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.form-check .form-check-input {\r\n  height: 25px;\r\n  width: 25px;\r\n  margin-top: -1px;\r\n  margin-right: 8px;\r\n  border: 2px solid var(--Casal-color);\r\n}\r\n.form-check .form-check-input:checked {\r\n  background-color: var(--Casal-color);\r\n  border-color: var(--Casal-color);\r\n}\r\n\r\n.cstTab {\r\n  border-bottom: 1px solid #b5c2da;\r\n  display: flex;\r\n  gap: 20px;\r\n  padding: 0px;\r\n}\r\n.cstTab li {\r\n  padding: 10px 20px;\r\n  background: #fff;\r\n  border-radius: 10px 10px 0 0;\r\n  border: 1px solid #b5c2da;\r\n  min-width: 200px;\r\n  margin-bottom: -1px;\r\n  opacity: 0.5;\r\n  cursor: pointer;\r\n}\r\n.cstTab li.active {\r\n  opacity: 1;\r\n}\r\n\r\n.cstTab.posTab {\r\n  display: inline-flex;\r\n  background: #eaeaea;\r\n  gap: 0;\r\n  border: 0;\r\n  border-radius: 10px 10px 0 0;\r\n  overflow: hidden;\r\n}\r\n.cstTab.posTab li {\r\n  min-width: auto;\r\n  border: 0;\r\n  opacity: 1;\r\n  border-radius: 0;\r\n  background: none;\r\n}\r\n\r\n.cstTab.posTab li.active {\r\n  background: #058bd3;\r\n  color: #fff;\r\n  border-radius: 10px 10px 0 0;\r\n}\r\n\r\n.pagination li.disabled a {\r\n  color: #ccc;\r\n  cursor: not-allowed;\r\n}\r\n\r\n/* ===================== Page Title =========================== */\r\n.pageTitle1 {\r\n  background: var(--White-Color);\r\n}\r\n.pageTitle1 h3 {\r\n  font-size: 24px;\r\n  color: #000;\r\n  font-weight: 600;\r\n}\r\n.pageTitle1 p {\r\n  font-size: 14px;\r\n  color: #000;\r\n}\r\n\r\n.rightModal.changeEmail {\r\n  background: #f2f2f2;\r\n}\r\n.changeEmail .lgIcon {\r\n  font-size: 50px;\r\n}\r\n.changeEmail h3 {\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n}\r\n.changeEmail p {\r\n  font-size: 16px;\r\n  color: #3c4248;\r\n}\r\n.taskModal.changeEmail .btnNobg,\r\n.taskModal.changeEmail .btnSubmit {\r\n  min-width: 150px;\r\n}\r\n\r\n.taskModal.changeEmail .btnNobg {\r\n  background: #fff;\r\n  border: 1px solid #9e9b9b;\r\n}\r\n.taskModal.changeEmail .btnSubmit {\r\n  background: #5544dc;\r\n  border: 1px solid #5544dc;\r\n}\r\n\r\n.taskModal.changeEmail .resend span {\r\n  font-size: 24px;\r\n}\r\n\r\n.taskModal.changeEmail .resend {\r\n  color: #5544dc;\r\n  font-size: 17px;\r\n  font-weight: 600;\r\n  text-decoration: none;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.withIcon {\r\n  position: relative;\r\n}\r\n.withIcon .icon {\r\n  position: absolute;\r\n  left: 14px;\r\n  top: 8px;\r\n  font-size: 20px;\r\n  color: #6d8297;\r\n}\r\n.withIcon .form-control {\r\n  height: 46px;\r\n  padding-left: 45px;\r\n}\r\n\r\n.transparentBtn button {\r\n  background: #fff;\r\n  border: 1px solid #000;\r\n  border-radius: 30px;\r\n  padding: 4px 10px 6px;\r\n  font-size: 14px;\r\n  width: 130px;\r\n}\r\n.transparentBtn button span {\r\n  font-size: 18px;\r\n  line-height: 22px;\r\n}\r\n.transparentBtn button.active {\r\n  border: 1px solid var(--primary-400);\r\n  color: var(--primary-400);\r\n  font-weight: 600;\r\n}\r\n\r\n.privacyPolicy h1 {\r\n  font-size: 32px;\r\n  font-weight: 700;\r\n  color: #000;\r\n}\r\n.privacyPolicy h2 {\r\n  font-size: 26px;\r\n  font-weight: 700;\r\n  color: #000;\r\n}\r\n\r\n.contactForm .form-group label {\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.contactForm .form-control {\r\n  height: 50px;\r\n}\r\n\r\n.contact .heading h2 {\r\n  font-size: 30px;\r\n  font-weight: 700;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n.contact .heading h2 span {\r\n  color: #ff9100;\r\n}\r\n\r\n.contact .heading p {\r\n  font-size: 16px;\r\n  font-weight: 400;\r\n  line-height: 1.7;\r\n  color: #212529;\r\n  margin: 20px 0;\r\n  padding: 0;\r\n}\r\n\r\n.contact .title h3,\r\n.contentPage h3 {\r\n  font-weight: 600;\r\n  font-size: 20px;\r\n}\r\n\r\n.contactDetail {\r\n  border-top: 1px solid #ccc;\r\n  border-bottom: 1px solid #ccc;\r\n}\r\n\r\n.contactDetail h3 {\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.contact .form-control {\r\n  padding: 15px 25px;\r\n  font-size: 16px;\r\n  margin-bottom: 20px;\r\n  background: #f4f4f4;\r\n  border: 1px solid #e9e9e9;\r\n  border-radius: 10px;\r\n  margin-top: 10px;\r\n}\r\n\r\n.contact .title p {\r\n  font-size: 14px;\r\n  font-weight: 400;\r\n  color: #999;\r\n  line-height: 1.6;\r\n  margin: 0 0 40px;\r\n}\r\n\r\n.contact .content .info i {\r\n  font-size: 30px;\r\n  padding: 0;\r\n  margin: 0 20px 0 0;\r\n  color: #0f417b;\r\n  text-align: center;\r\n  width: 20px;\r\n  vertical-align: super;\r\n}\r\n\r\n.contact .content .info h4 {\r\n  font-size: 14px;\r\n  line-height: 1.4;\r\n  color: #3b3b3b;\r\n}\r\n\r\n.contact .content .info h4 span {\r\n  font-size: 16px;\r\n  font-weight: 400;\r\n  color: #212529;\r\n}\r\n\r\n.contentPage h3 {\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.contentPage h2 {\r\n  font-size: 22px;\r\n  font-weight: 500;\r\n  margin: 20px 0 10px;\r\n}\r\n\r\n.contentPage h5,\r\n.contentPage p,\r\n.contentPage ul li {\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.contentPage h5 {\r\n  font-weight: 500;\r\n  font-size: 18px;\r\n}\r\n\r\n.contentPage ul {\r\n  margin: 0 0 10px;\r\n  padding-left: 20px;\r\n}\r\n\r\n.contentPage ul li {\r\n  list-style: square;\r\n  line-height: 22px;\r\n}\r\n\r\n.innerHeader {\r\n  background: #f8f9fa;\r\n}\r\n\r\n.contact,\r\n.innerHeader {\r\n  padding: 50px 0;\r\n}\r\n\r\n.contact .content .info,\r\na.home-btn {\r\n  margin-top: 30px;\r\n}\r\n\r\n.heading h2 {\r\n  font-size: 2rem;\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.contactDetail .info {\r\n  text-align: center;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.info h4 {\r\n  margin: 0;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
